module.exports = __webpack_public_path__ + "static/media/EHS-Complaints-Policy-easy-read-version.de8b3c58.pdf";